import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BlockerHeaderInlineStyles = /*#__PURE__*/function () {
  function BlockerHeaderInlineStyles() {
    _classCallCheck(this, BlockerHeaderInlineStyles);
  }

  _createClass(BlockerHeaderInlineStyles, null, [{
    key: "headerContainer",
    value: function headerContainer(_ref) {
      var _ref$layout = _ref.layout,
          type = _ref$layout.type,
          dialogBorderRadius = _ref$layout.dialogBorderRadius,
          _ref$design = _ref.design,
          borderWidth = _ref$design.borderWidth,
          borderColor = _ref$design.borderColor,
          restDesign = _objectWithoutProperties(_ref$design, ["borderWidth", "borderColor"]),
          _ref$headerDesign = _ref.headerDesign,
          inheritBg = _ref$headerDesign.inheritBg,
          bg = _ref$headerDesign.bg,
          padding = _ref$headerDesign.padding,
          antiAdBlocker = _ref.customCss.antiAdBlocker;

      var style = {
        padding: padding.map(function (p) {
          return "".concat(p, "px");
        }).join(" "),
        background: inheritBg ? restDesign.bg : bg,
        borderRadius: type === "dialog" ? "".concat(dialogBorderRadius, "px ").concat(dialogBorderRadius, "px 0 0") : undefined
      };

      if (type === "dialog" && borderWidth > 0) {
        style.borderTop = "".concat(borderWidth, "px solid ").concat(borderColor);
        style.borderLeft = style.borderTop;
        style.borderRight = style.borderTop;
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-header-container",
        style: style
      };
    }
  }, {
    key: "header",
    value: function header(_ref2) {
      var textAlign = _ref2.design.textAlign,
          _ref2$headerDesign = _ref2.headerDesign,
          inheritTextAlign = _ref2$headerDesign.inheritTextAlign,
          restHeaderDesign = _objectWithoutProperties(_ref2$headerDesign, ["inheritTextAlign"]),
          antiAdBlocker = _ref2.customCss.antiAdBlocker;

      var useTextAlign = inheritTextAlign ? textAlign : restHeaderDesign.textAlign;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-header",
        style: {
          margin: "auto",
          display: "flex",
          justifyContent: useTextAlign === "center" ? "center" : useTextAlign === "right" ? "flex-end" : undefined,
          alignItems: "center"
        }
      };
    }
  }, {
    key: "headline",
    value: function headline(_ref3) {
      var _ref3$headerDesign = _ref3.headerDesign,
          fontSize = _ref3$headerDesign.fontSize,
          fontColor = _ref3$headerDesign.fontColor,
          fontInheritFamily = _ref3$headerDesign.fontInheritFamily,
          fontFamily = _ref3$headerDesign.fontFamily,
          antiAdBlocker = _ref3.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-headline",
        style: {
          color: fontColor,
          fontSize: +fontSize,
          lineHeight: 1.8,
          fontFamily: fontInheritFamily ? undefined : fontFamily
        }
      };
    }
  }, {
    key: "headerSeparator",
    value: function headerSeparator(_ref4) {
      var type = _ref4.layout.type,
          design = _ref4.design,
          _ref4$headerDesign = _ref4.headerDesign,
          borderWidth = _ref4$headerDesign.borderWidth,
          borderColor = _ref4$headerDesign.borderColor,
          antiAdBlocker = _ref4.customCss.antiAdBlocker;
      var style = {
        height: +borderWidth,
        background: borderColor
      };

      if (type === "dialog" && design.borderWidth > 0) {
        style.borderLeft = "".concat(design.borderWidth, "px solid ").concat(design.borderColor);
        style.borderRight = style.borderLeft;
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-header-separator",
        style: style
      };
    }
  }]);

  return BlockerHeaderInlineStyles;
}();

export { BlockerHeaderInlineStyles };